import React, { useState, useEffect } from 'react';

/**
 * Modal para cerrar un servicio continuo. Pide la fecha de cierre (no automática).
 * @param {boolean} isOpen
 * @param {() => void} onClose
 * @param {(endDate: string) => void} onConfirm - endDate en formato YYYY-MM-DD
 * @param {string} serviceName - Nombre/código del servicio para el mensaje
 * @param {boolean} loading
 */
const CloseServiceModal = ({ isOpen, onClose, onConfirm, serviceName, loading = false }) => {
  const today = new Date().toISOString().slice(0, 10);
  const [closeDate, setCloseDate] = useState(today);

  useEffect(() => {
    if (isOpen) {
      setCloseDate(new Date().toISOString().slice(0, 10));
    }
  }, [isOpen]);

  const handleConfirm = () => {
    if (!closeDate) return;
    onConfirm(closeDate);
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full">
        <div className="p-6">
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Cerrar Servicio Continuo
          </h3>
          <p className="text-gray-700 mb-4">
            {serviceName
              ? `¿Estás seguro de cerrar el servicio continuo "${serviceName}"? Una vez cerrado, no podrás agregar más registros de avance.`
              : 'Una vez cerrado, no podrás agregar más registros de avance.'}
          </p>
          <div className="mb-6">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Fecha de cierre <span className="text-red-500">*</span>
            </label>
            <input
              type="date"
              value={closeDate}
              onChange={(e) => setCloseDate(e.target.value)}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-teal-500"
              required
            />
          </div>
          <div className="flex justify-end gap-3">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-md transition-colors disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={loading || !closeDate}
              className="px-4 py-2 text-sm font-medium text-white bg-orange-600 hover:bg-orange-700 rounded-md transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Cerrando...' : 'Cerrar'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CloseServiceModal;
